import React, {Component} from 'react';
import { Row, Col } from 'react-bootstrap';
import { Link } from 'react-router';

import piano01 from '../images/piano-01-md.jpg';
import piano02 from '../images/piano-02-md.jpg';
import sheet01 from '../images/sheet-01-md.jpeg';
import map01 from '../images/map-01-md.jpg';
import map02 from '../images/map-02-o.jpg';

export default class Home extends Component {
    render() {
        return (
            <div id="home" className="transition-item">
                <Row>
                    <Col sm={12}>
                        <div className="jumbotron text-center" style={{paddingTop: 0}}>
                            <h1>
                                Willkommen!
                            </h1>
                            <p className="lead">
                                Sie suchen Klavierunterricht in München? Hier sind Sie richtig!
                            </p>
                        </div>
                    </Col>
                    <Col sm={8}>
                        <Teaser image={piano01} dark={true}>
                            <h1>Klavierunterricht für alle!</h1>
                            <p className="lead">
                                Ich bin Klavierlehrerin mit jahrelanger pädagogischer und konzertierender Erfahrung
                                und möchte Sie bei Ihrer musikalischen Reise begleiten!
                                <br/>
                                Egal ob klein oder groß, Anfänger, Wiedereinsteiger oder Profi, bei mir sind Sie in
                                guten Händen.
                            </p>
                            <Link to="/about" className="btn btn-primary">Mehr über mich</Link>
                        </Teaser>
                        <Row>
                            <Col sm={6}>
                                <Teaser image={piano02}>
                                    <h3>Probestunde vereinbaren</h3>
                                    <p>
                                        Vereinbaren Sie noch heute Ihre erste Probestunde!
                                        Gerne berate ich Sie persönlich per Email oder am Telefon.
                                    </p>
                                    <Link to="/contact" className="btn btn-primary">Kontakt aufnehmen</Link>
                                </Teaser>
                            </Col>
                            <Col sm={6}>
                                <Teaser image={map02} dark={true}>
                                    <h3>Anfahrt</h3>
                                    <p>Kontakt- und Anfahrtinformationen finden Sie hier.</p>
                                    <Link to="/contact" className="btn btn-primary">Mehr</Link>
                                </Teaser>
                            </Col>
                        </Row>
                    </Col>
                    <Col sm={4}>
                        <Teaser>
                            <h3>News</h3>
                            <p>
                                Wir gratulieren unseren Preisträgern im Wettbewerb "Jugend Musiziert" 2018.
                            </p>
                            <Link to="/news" className="btn btn-primary">Mehr</Link>
                        </Teaser>
                        <Teaser image={sheet01}>
                            <h3>Nächste Termine</h3>
                            <p>Jahresabschlusskonzerte im Juni und Juli</p>
                            <Link to="/events" className="btn btn-primary">Mehr</Link>
                        </Teaser>
                    </Col>
                </Row>
            </div>
        )
    }
}

function Teaser(props) {

    let className = 'card no-padding';

    let image = false;

    if (props.image) {
        className += ' has-image';
        image = <div className="image" style={{backgroundImage: `url(${props.image})`}}></div>;

        if (props.dark) {
            className += ' dark';
        }
    }

    return (
        <figure className={className}>
            {image}
            <figcaption>
                {props.children}
            </figcaption>
        </figure>
    )
}


// WEBPACK FOOTER //
// ./src/components/Home.js